(function() {
  angular.module('cfn').factory('confirmModalPersistentService', [
    '$dialog',
    'i18nFilter',
    'UserSessionStorageService',
    function($dialog, i18nFilter, UserSessionStorageService) {
      var namespaces = {
        __GLOBAL__: 'global',
        BOOKING_LIST: 'booking-list'
      };

      var service = {
        confirmDelete: confirmDelete,
        NAMESPACES: namespaces
      };
      return service;

      /**
       * @private
       * @param  {string} title
       * @param  {string} message
       * @param  {array} buttons
       * @param  {string} namespace
       * @return {Dialog}
       */
      function dialog(title, message, buttons, namespace) {
        return $dialog.dialog({
          templateUrl: require('./confirm-modal-persistent.html'),
          controller: 'ConfirmModalPersistentController',
          namespace: namespace,
          resolve: {
            model: function() {
              return {
                title: title,
                message: message,
                buttons: buttons
              };
            }
          }
        });
      }

      /**
       * show confirm delete dialog
       * @param  {function} okCallback
       * @param  {string} namespace optional
       */
      function confirmDelete(okCallback, namespace) {
        namespace = namespace || namespaces.__GLOBAL__;
        var storageData =
          UserSessionStorageService.createStorage(
            'confirmModalPersistent'
          ).load() || {};
        if (storageData[namespace] === true) {
          okCallback();
          return;
        }
        dialog(
          i18nFilter(
            'fe.common.message.reallyDelete.title',
            'Confirm Deletion'
          ),
          i18nFilter(
            'fe.common.message.reallyDelete.batch.message',
            'Are you sure you want to delete this items?'
          ),
          [
            {
              result: 'ok',
              label: i18nFilter('fe.common.delete', 'Delete'),
              cssClass: 'btn-primary float-right'
            },
            {
              result: 'cancel',
              label: i18nFilter('fe.common.cancel', 'Cancel'),
              cssClass: 'float-right'
            }
          ],
          namespace
        )
          .open()
          .then(function(result) {
            if (result === 'ok') {
              okCallback();
            }
          });
      }
    }
  ]);
})();
